'use client'
import React, { useContext, useState, useEffect } from 'react'
import { useInView } from "react-intersection-observer";
import { FaCheck, FaPlus } from 'react-icons/fa6'
import { translateIt } from '@/data/translations'
import { LANGUAGE } from '@/data/constants'
import { toast } from 'sonner'
import Styling from '@/library/styling'
import { COUNTRY_ID } from '@/data/constants'
import { BookmarkAPI, SocializeAPI } from '@/library/entities/socialize/data/socialize'
import { UserContext } from '@/library/entities/core/user/contexts/UserContext'
import ButtonWSpinner from '@/library/blocks/buttons/ButtonWSpinner';
import { FaPlusSquare } from 'react-icons/fa';
import LoginModal from '@/library/entities/core/user/components/authentication/LoginModal';

const appName = 'market'
const modelName = 'instrument'

export default function InstrumentFollowButton(props) {
  const {
    entityId,
    className = '',
    theme = 'tertiary',
  } = props

  const { ref, inView, entry } = useInView({
    threshold: 0,
    triggerOnce: true
  });
  const [currentFollow, setCurrentFollow] = useState(null)
  const [openLoginModal, setOpenLoginModal] = useState(false)
  const [isUpdatingFollow, setIsUpdatingFollow] = useState(false)
  const { isAuthenticated, followInstrumentList, getAndSetFollowInstrumentList, isLoadingFollowInstrumentList } = useContext(UserContext)

  const defaultClassName = `bg-${theme} hover:bg-${theme}-200 transition-all duration-300 text-white px-4 py-1 rounded-full flex items-center gap-2 w-32`

  const handleOnClick = async () => {
    if (!isAuthenticated) {
      setOpenLoginModal(!!!openLoginModal)
      toast.error(<>
        {translateIt(COUNTRY_ID, 'login_to_react')}
        <LoginModal
          countryId={COUNTRY_ID}
          size="sm"
          trigger={
            <div className={`underline cursor-pointer ${Styling.sizes.sm.strong} `}>
              {translateIt(COUNTRY_ID, 'login__login')}
            </div>
          }
        />
      </>)
      return
    }
    setIsUpdatingFollow(true)
    await BookmarkAPI.create({ appName, modelName, entityId, emotionId: BookmarkAPI.EMOTIONS.FOLLOW })
    await getAndSetFollowInstrumentList()
    setIsUpdatingFollow(false)
  }

  useEffect(() => {
    if (inView) {
      const connectedToKind = SocializeAPI.getConnectedToKind(appName, modelName)
      const entityKey = SocializeAPI.getEntityKey(connectedToKind)
      const currentFollow = followInstrumentList.find(bookmarket => {
        return bookmarket.connected_to_kind === connectedToKind && bookmarket[entityKey] === parseInt(entityId)
      })
      setCurrentFollow(currentFollow)
    }
  }, [inView, followInstrumentList, entityId])

  return (
    <>
      <div ref={ref} className={className}>
        <ButtonWSpinner

          className={defaultClassName}
          onClick={handleOnClick}
          isLoading={isUpdatingFollow || isLoadingFollowInstrumentList}
          label={currentFollow?.is_active ? (
            <>
              <FaCheck />
              {translateIt(LANGUAGE, 'following')}
            </>
          ) : (
            <>
              <FaPlus />
              {translateIt(LANGUAGE, 'follow')}
            </>
          )}
          color={theme}
          variant={currentFollow?.is_active ? 'solid' : 'bordered'}
          type="button"
          disabled={isUpdatingFollow || isLoadingFollowInstrumentList}
          spinnerColor="white"
          spinnerSize="sm"
        />
      </div>
    </>
  )
}
